import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { base_url } from "../Api/Api";
import { Loader } from "../Global/Loader";

import Navbar from "../Global/Navbar";
import Header from "../Global/Header";
import Itemnews from "./Itemnews";
import InfiniteScroll from "react-infinite-scroll-component";

const News = (props) => {
  const [state, setState] = useState({
    data: [], // data news
    loader: true, // loader status
    page: 1,
    lastPage: 1,
  });

  useEffect(() => {
    if (JSON.parse(localStorage.getItem("logined")) == null) {
      props.history.push(`/Entrance`);
    }

    base_url
      .get(`latest_news?page=${state.page}`)
      .then((response) => {
        setState({
          ...state,
          data: response.data.latestNews.data,
          loader: false,
          lastPage: response.data.latestNews.last_page,
        });
      })
      .catch((error) => {
        if (error.response != undefined) {
          console.log(error);
          if (error.response.status == 401) {
            localStorage.clear();
            props.history.push(`/Entrance`);
            window.location.reload();
          }
        }
      });
  }, []);

  const getNews = () => {
    let page = state.page + 1;
    base_url
      .get(`latest_news?page=${page}`)
      .then((response) => {
        setState((perv) => ({
          ...state,
          data: [...perv.data, ...response.data.latestNews.data],
          loader: false,
        }));
      })
      .catch((error) => {
        if (error.response != undefined) {
          console.log(error);
          if (error.response.status == 401) {
            localStorage.clear();
            props.history.push(`/Entrance`);
            window.location.reload();
          }
        }
      })
      .finally(() => {
        setState((perv) => ({ ...perv, page: perv.page + 1 }));
      });
  };

  return (
    <div className="instructpg news">
      <Loader active={state.loader} />
      <Header />
      {state.data.length === 0 ? (
        <div className={`inner-news ${state.loader ? "" : "active"}`}>
          <span className="no-content">اطلاعاتی وجود ندارد</span>
        </div>
      ) : (
        <div
          id="scrollableDiv"
          className={`inner-news ${state.loader ? "" : "active"}`}
        >
          <InfiniteScroll
            dataLength={state.data.length}
            next={() => {
              getNews();
            }}
            hasMore={state.page === state.lastPage + 1 ? false : true}
            scrollableTarget="scrollableDiv"
          >
            {state.data.map((info) => (
              <Itemnews
                key={info.id}
                id={info.id}
                pic={info.image}
                title={info.title}
                time={info.string_date}
                comment={info.comment_count}
                tags={info.tags}
              />
            ))}
          </InfiniteScroll>
        </div>
      )}
      <Navbar />
    </div>
  );
};

export default News;
